// types
import type { AdditionalSelectors } from '../types';

/**
 * Thin façade over the host-supplied selectors.
 *
 * The DDJ activity owns no Redux slice, so unlike other activities this class
 * does not extend BaseSelectors — it only adapts the host's state readers to a
 * stable shape the components can depend on, and applies the defaults for the
 * optional ones.
 */
export class Selectors {
    constructor(public additionalSelectors: AdditionalSelectors) {}

    getDealXgId = (state: any): string => this.additionalSelectors.getDealXgId(state);

    getDealRefId = (state: any): string => this.additionalSelectors.getDealRefId(state);

    getPartnerCode = (state: any): string | undefined => this.additionalSelectors.getPartnerCode?.(state);

    getPartnerDealerId = (state: any): string | undefined => this.additionalSelectors.getPartnerDealerId?.(state);
}

/**
 * Stand-in used before the host calls init().
 *
 * DDJPreloader is mounted at the app shell level, so it renders on the very
 * first paint — before BOOTSTRAP_SUCCESS has run the host's init(). Returning
 * undefined for everything is the semantically correct answer at that point:
 * there is no deal yet, so the preloader fetches the loader script but defers
 * creating the PBC element until a dealRefId exists.
 */
export const uninitializedSelectors: AdditionalSelectors = {
    getDealXgId: () => '',
    getDealRefId: () => '',
    getPartnerCode: () => undefined,
    getPartnerDealerId: () => undefined
};
